import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'
// components
import { ReduxInput, ReduxSelect } from 'components/FormElements/ReduxForm'
import Grid from '@mui/material/Grid2'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// views
import { ActionsWrapper, Content } from 'themes/views/modals'
// constants
import { Forms } from 'constants/forms'
import { LICENCE_TYPES_OPTIONS, LICENCES_TYPES, SUBSCRIPTION_LEVEL_OPTIONS } from 'constants/licences'
// types
import { InjectedFormProps } from 'redux-form/lib/reduxForm'
// utils
import { required } from 'utils/validators'
import { getValueFromOption } from 'utils/form'

const selector = formValueSelector(Forms.LICENCE_FORM)

interface Props {
  onCancelClick: () => void
}

const SetLicenceForm: React.FC<InjectedFormProps<any, Props> & Props> = ({ handleSubmit, onCancelClick }) => {
  const licenceType = useSelector((state) => getValueFromOption(selector(state, 'licenceType')))

  const isUserLicence = licenceType === LICENCES_TYPES.USER

  const validations = isUserLicence ? [required] : []

  return (
    <form onSubmit={handleSubmit}>
      <Content>
        <Grid container spacing={2}>
          <Grid size={12}>
            <ReduxSelect
              label='Subscription level'
              name='subscriptionLevel'
              isDisabled={!isUserLicence}
              validate={validations}
              options={SUBSCRIPTION_LEVEL_OPTIONS}
            />
          </Grid>
          <Grid size={12}>
            <ReduxSelect label='License Type' name='licenceType' options={LICENCE_TYPES_OPTIONS} />
          </Grid>
          {Object.values(LICENCES_TYPES).includes(licenceType) && (
            <Grid size={12}>
              <ReduxInput label='Licences' name='standardLicences' disabled={!isUserLicence} validate={validations} />
            </Grid>
          )}
        </Grid>
      </Content>
      <ActionsWrapper>
        <Grid container spacing={2}>
          <Grid>
            <Button layout={BUTTON_LAYOUTS.PURPLE} type='submit'>
              Save
            </Button>
          </Grid>
          <Grid>
            <Button layout={BUTTON_LAYOUTS.WHITE} onClick={onCancelClick}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </ActionsWrapper>
    </form>
  )
}

export default reduxForm<any, Props>({
  form: Forms.LICENCE_FORM,
  enableReinitialize: true,
  initialValues: {
    licenceType: LICENCES_TYPES.USER
  }
})(SetLicenceForm)
